var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.66045V5.66045M1 5.66045H5M1 5.66045L4.09333 2.75378C5.01394 1.83473 6.2083 1.23976 7.49645 1.05853C8.7846 0.87729 10.0968 1.1196 11.2352 1.74896C12.3737 2.37831 13.2768 3.36061 13.8084 4.54785C14.3401 5.73509 14.4715 7.06295 14.1828 8.33136C13.8942 9.59977 13.2011 10.74 12.2081 11.5803C11.2151 12.4206 9.97583 12.9153 8.67714 12.9901C7.37846 13.0648 6.09065 12.7155 5.00777 11.9947C3.92489 11.2739 3.1056 10.2207 2.67333 8.99378",
    stroke: "#64C3FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.7038609e1238c580b9a0f95f1f3fce05.svg";
export { ForwardRef as ReactComponent };